import React from 'react';

import Image from 'next/legacy/image';

import Spinner from '@repo/editor/src/components/utilities/Spinner/Spinner';
import { Spacer } from '@repo/ui/components/Spacer';
import { H6 } from '@repo/ui/components/Typography';
import { useTheme } from '@repo/ui/theming';

import { FlexColumn } from 'styles/layouts';
import { LayoutSwitch } from 'styles/queries';

import { NoPostsLoadedProps } from './types';

const NoPostsLoaded: React.FC<NoPostsLoadedProps> = ({ loading }) => {
  const { isDarkTheme } = useTheme();

  return (
    <FlexColumn
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '290px' }}
    >
      {loading && <Spinner size="45px" />}
      {!loading && (
        <LayoutSwitch
          desktopProps={{ height: '240', width: '304' }}
          mobileProps={{ height: '140', width: '177' }}
        >
          <Image
            alt="Nothing Found"
            className="nothing-found-illustration"
            src={
              isDarkTheme
                ? '/images/newTheme/dark/Empty.png'
                : '/images/newTheme/light/Empty.png'
            }
          />
        </LayoutSwitch>
      )}
      <Spacer height="24px" />
      <H6>{loading ? 'Loading' : 'No designs found'}</H6>
    </FlexColumn>
  );
};

export default NoPostsLoaded;
